import { Badge } from '@mantine/core'

interface InfoCardProps {
  className?: string
  type: 'メンテナンス' | 'アップデート' | '障害報告'
  title?: string
  color: 'red' | 'green' | 'blue'
  children: React.ReactNode
}

function InfoCard({ className, type, color, title, children }: InfoCardProps) {
  return (
    <div className={`${className} bg-white p-4 border shadow-sm rounded-lg hover:shadow-lg`}>
      <Badge className='mb-4' color={color} variant='light'>
        {type}
      </Badge>
      {title !== '' && <div className='text-base font-semibold mb-4'>{title}</div>}
      {children}
    </div>
  )
}

InfoCard.defaultProps = {
  className: '',
  title: '',
}

export default InfoCard
